<nav class="category-menu" [attr.aria-label]="navAriaLabel" (mouseleave)="!isMobile && close()">
  <ul #bar class="category-menu-bar" [class.category-menu-root-hidden]="isMobile && active">
    <li *ngFor="let category of primary; let i = index" class="category-menu-item">
      <button *ngIf="category.children?.length; else primaryLink" type="button"
        class="category-menu-trigger" [class.active]="active === category"
        [attr.aria-expanded]="active === category" aria-controls="category-menu-panel"
        (mouseenter)="!isMobile && open(category, $event)"
        (click)="open(category, $event, true)" (keydown.arrowdown)="open(category, $event); $event.preventDefault()">
        <span>{{ category.title }}</span><cx-icon [type]="isMobile ? iconType.CARET_RIGHT : iconType.CARET_DOWN" aria-hidden="true"></cx-icon>
      </button>
      <ng-template #primaryLink>
        <ng-container *ngTemplateOutlet="link; context: { category: category }"></ng-container>
      </ng-template>
    </li>
    <li *ngIf="overflow.length" class="category-menu-item category-menu-more">
      <button type="button" class="category-menu-trigger" [class.active]="active === 'more'"
        [attr.aria-expanded]="active === 'more'" aria-controls="category-menu-panel"
        (mouseenter)="!isMobile && open('more', $event)" (click)="open('more', $event, true)"
        (keydown.arrowdown)="open('more', $event); $event.preventDefault()">
        <span>{{ 'navigation.moreCategories' | cxTranslate }}</span><cx-icon [type]="isMobile ? iconType.CARET_RIGHT : iconType.CARET_DOWN" aria-hidden="true"></cx-icon>
      </button>
    </li>
  </ul>

  <div *ngIf="active" id="category-menu-panel" class="category-menu-panel">
    <button #backButton *ngIf="isMobile" type="button" class="category-menu-back" (click)="close(true)">
      <cx-icon [type]="iconType.ARROW_LEFT" aria-hidden="true"></cx-icon>
      {{ active === 'more' ? ('navigation.moreCategories' | cxTranslate) : active.title }}
    </button>
    <div class="category-menu-columns">
      <ul *ngFor="let column of columns" class="category-menu-column">
        <li *ngFor="let category of column" class="category-menu-group">
          <div class="category-menu-heading"><ng-container *ngTemplateOutlet="link; context: { category: category }"></ng-container></div>
          <ul *ngIf="category.children?.length">
            <li *ngFor="let child of category.children">
              <ng-container *ngTemplateOutlet="link; context: { category: child }"></ng-container>
              <!-- More is a presentation container, not an extra category level. -->
              <ul *ngIf="active === 'more' && child.children?.length" class="category-menu-third-level">
                <li *ngFor="let grandchild of child.children">
                  <ng-container *ngTemplateOutlet="link; context: { category: grandchild }"></ng-container>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>

  <div class="category-menu-measure" aria-hidden="true" inert>
    <span #measure *ngFor="let category of categories" class="category-menu-trigger">
      <span>{{ category.title }}</span><cx-icon *ngIf="category.children?.length" [type]="iconType.CARET_DOWN"></cx-icon>
    </span>
    <span #moreMeasure class="category-menu-trigger category-menu-more">
      <span>{{ 'navigation.moreCategories' | cxTranslate }}</span><cx-icon [type]="iconType.CARET_DOWN"></cx-icon>
    </span>
  </div>
</nav>

<ng-template #link let-category="category">
  <cx-generic-link *ngIf="!category.isFacetGroup && category.url; else heading" [url]="getNodeUrl(category)" [target]="category.target"
    [class]="category.styleClasses" [style]="category.styleAttributes" (click)="select(category)">
    {{ category.title }}
  </cx-generic-link>
  <ng-template #heading>
    <button *ngIf="category.customClickHandler; else label" type="button" (click)="select(category)">{{ category.title }}</button>
    <ng-template #label><span class="category-menu-label">{{ category.title }}</span></ng-template>
  </ng-template>
</ng-template>
